import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useGetCategoryListQuery } from "../../../Services/CategoryService";
import {
  useGetPopularInCountryProductQuery,
  useLazySearchProductsQuery,
} from "../../../Services/ProductService";
import { setPopularProduct } from "../../../Redux/Slices/SettingSlice";
import { useSelector } from "react-redux";
import Constant from "../../../Config/Constant";
interface Props {
  handleCloseDropdowns: () => void;
  dispatch: any;
}

const GamingMegaMenu = ({ handleCloseDropdowns, dispatch }: Props) => {
  const { data } = useGetCategoryListQuery();
  const { data: topPopularProductData, isLoading } =
    useGetPopularInCountryProductQuery(
      `?keyword=gift&sortBy=isPopular&page=1&limit=8`,
    );
  const [searchProductsTrigger, { data: searchProductsData }] =
    useLazySearchProductsQuery();

  const trendingProducts: any[] = useSelector(
    (state: any) => state.SettingSlice.trendingProducts,
  );
  const popularProducts: any[] = useSelector(
    (state: any) => state.SettingSlice.popularProducts,
  );

  window.addEventListener("click", (event) => {
    const target = event.target as HTMLElement;
    if (target.classList.contains("hlink")) {
      const link = target.getAttribute("href");
      if (link) {
        handleCloseDropdowns();
      }
    }
  });

  useEffect(() => {
    searchProductsTrigger(`?countryCode=DE&limit=5`);
  }, [searchProductsData]);

  useEffect(() => {
    if (popularProducts.length === 0) {
      if (
        topPopularProductData &&
        topPopularProductData?.products &&
        topPopularProductData?.products.length > 0
      ) {
        dispatch(setPopularProduct(topPopularProductData?.products));
      }
    }
  }, [topPopularProductData]);

  return (
    <div className="bg-light-background dark:bg-dark-foreground p-6 px-4 md:px-10 lg:px-20 font-sans">
      {/* Grid with Centered Divider */}
      <div className=" w-full mx-auto px-4 sm:px-6 lg:px-0 py-1">
        <div className="grid grid-cols-1 lg:grid-cols-4 sm:grid-cols-2 gap-y-8 lg:divide-x-2 lg:divide-gray-300 dark:lg:divide-gray-600">
          {/* Featured Section */}
          <div className="">
            <h3 className="font-bold text-lg mb-4 text-gray-900 dark:text-gray-100">
              Featured
            </h3>
            <ul className="space-y-2 text-gray-900 dark:text-gray-100">
              <li>
                <Link
                  className="hlink hover:text-blue-600 dark:hover:text-gray-100 hover:underline"
                  to={`/gift-cards/Gaming`}
                >
                  All Gaming
                </Link>
              </li>
              <li>
                <Link
                  className="hlink hover:text-blue-600 dark:hover:text-gray-100 hover:underline"
                  to={`/gift-cards/popular/Gaming`}
                >
                  Popular
                </Link>
              </li>
              <li>
                <Link
                  className="hlink hover:text-blue-600 dark:hover:text-gray-100 hover:underline"
                  to={`/gift-cards/recently-added/Gaming`}
                >
                  Recently Added
                </Link>
              </li>
              {/* <li>
                <Link
                  className="hlink hover:text-blue-600 dark:hover:text-gray-100 hover:underline"
                  to={`/gift-cards/cashback/Gaming`}
                >
                  Cashback
                </Link>
              </li> */}
            </ul>
          </div>

          {/* Categories Section */}
          <div className="ps-10 col-span-2">
            <h3 className="font-bold text-lg mb-4 text-gray-900 dark:text-gray-100">
              Categories
            </h3>
            <ul className="grid grid-cols-2 md:grid-cols-3 gap-2 text-gray-900 dark:text-gray-100">
              {data &&
                data?.length > 0 &&
                data?.map((item) => {
                  if (
                    item?.parentCategoryName ===
                    Constant.PARENT_CATEGORY_NAME.GAMING
                  ) {
                    return (
                      <li
                        key={item?._id}
                        className="text-sm text-gray-700 dark:text-gray-400"
                      >
                        <Link
                          className="hlink hover:text-blue-600 dark:hover:text-gray-100 hover:underline"
                          to={`/gift-cards/${item?.categoryName}/${item?.parentCategoryName}`}
                        >
                          {item?.categoryName}
                        </Link>
                      </li>
                    );
                  } else {
                    return null;
                  }
                })}
            </ul>
          </div>

          {/* Popular in Germany Section */}
          <div className="px-10">
            <h3 className="font-bold text-lg mb-4 text-gray-900 dark:text-gray-100">
              Popular in Germany
            </h3>
            <ul className="space-y-2 text-gray-900 dark:text-gray-100">
              {searchProductsData &&
                searchProductsData.products &&
                searchProductsData.products.length > 0 &&
                searchProductsData.products.map(
                  (
                    item: { _id: string; productName: string },
                    index: number,
                  ) => (
                    <li
                      key={index}
                      className="text-sm text-gray-700 dark:text-gray-400"
                    >
                      <Link
                        className="hlink hover:text-blue-600 dark:hover:text-gray-100 hover:underline"
                        //   to={`/gift-cards`}
                        to={`/gift-cards/product-details/${item?._id}/${item?.productName}`}
                      >
                        {item.productName}
                      </Link>
                    </li>
                  ),
                )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GamingMegaMenu;
